import dayjs from 'dayjs'
import React from 'react'
import ReactApexChart, { type Props } from 'react-apexcharts'

export interface seriesData {
  name: string
  data: number[]
}

export interface ReportData {
  name: string
  type: string
  categories: string[]
  series: seriesData[]
  colors: string[]
  suffix: string
}

export function getReactApexChartBar (reportData: ReportData, height: string, isHistory: boolean, setSelectedDate?: React.Dispatch<React.SetStateAction<dayjs.Dayjs>>): any {
  const categories = reportData.categories
  const chartOptions: Props = {
    series: reportData.series,
    options: {
      chart: {
        height: 300,
        type: 'bar',
        background: 'transparent',
        toolbar: {
          show: false
        },
        events: {
          dataPointSelection: function (event, chartContext, config) {
            if (isHistory && setSelectedDate !== undefined) {
              console.log(categories[config.dataPointIndex])
              setSelectedDate(dayjs(categories[config.dataPointIndex]))
            }
            // console.log(config.config.series[config.seriesIndex])
            // console.log(config.config.series[config.seriesIndex].name)
            // console.log(config.config.series[config.seriesIndex].data[config.dataPointIndex])
          }
        },
        zoom: {
          enabled: false
          // autoScaleYaxis: true
        }
      },
      theme: { mode: 'dark' },
      colors: reportData.colors,
      plotOptions: {
        bar: {
          borderRadius: 2,
          columnWidth: '45%',
          dataLabels: {
            position: 'center' // top, center, bottom
          }
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#313031']
      },
      dataLabels: {
        enabled: false,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      xaxis: {
        categories,
        tickPlacement: 'on',
        position: 'bottom',
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: true
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: false
        },
        labels: {
          show: true,
          style: {
            colors: '#979798'
          },
          formatter: function (val) {
            const date = new Date(val).toDateString().split(' ')
            if (isHistory) {
              return `${date[2]} ${date[1]}`
            } else {
              return `${date[0]}`
            }
          }
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        // decimalsInFloat: 0,
        axisTicks: {
          show: false
        },
        labels: {
          show: true,
          style: {
            colors: '#bbbbbc'
          },
          formatter: function (val) {
            const s: string = reportData.suffix
            return `${val.toFixed(2)} ${s} units`
          }
        }
      }
    }
  }

  return (
      <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type='bar' height={height}
      />
  )
}
